import React from 'react';

const Widget = () => {
    return (
        <div className="widget-column">
        <iframe
          width="369"
          height="379"
          loading="lazy"
          src="https://cybermap.kaspersky.com/en/widget/dynamic/dark"
          frameBorder="0"
        ></iframe>
      </div>
    );
};

export default Widget;